import { formatDate } from "helpers/format";
import { generateColorByString } from "helpers/random";
import { AppDataContext } from "pages/app";
import { useContext, useState } from "react";

export class User {
  constructor(data) {
    if(data){
      this.id = data.id
      this.name = `${data.name} ${data.lastname}`
      this.email = data.email
      this.profile = data.profile
      this.companies = data.companies
      this.image = data.url_image_profile
      this.color = generateColorByString(this.email);
      this.can_make_adhesion = data.can_make_adhesion
      this.company_blocked = data.company_blocked
    }
  }

  setListYears(fiscal_years){
    this.fiscal_year = fiscal_years[fiscal_years.length - 1]
    this.fiscal_years = fiscal_years
  }

  setCurrentDate(date){
    this.current_date = date
  }

  isLogged = () => {
    return !!this.id;
  }

  isMasterAgent(){
    if (this.companies) {
      const companies = this.companies.filter(c => c.company_type_id == 2)
      if (companies.length == 1) {
        let company = companies[0]
        if (this.profile.profile_type_id != 1
          && this.profile.profile_type_id != 3 
          && company
        ) {
          return !!company.is_masteragent
        }
      }
    }

    if ([1, 46, 47, 48, 49].includes(this.profile.id)) {
      return true
    }

    return false

  }

  isElite(){
    if (this.companies) {
      const companies = this.companies.filter(c => c.company_type_id === 2)
      if (companies.length == 1) {
        let company = companies[0]
        if (this.profile.profile_type_id != 1
          && this.profile.profile_type_id != 3 
          && company
        ) {
          return !!([...company.fiscal_years_elite, ...company.fiscal_years_scancash].length > 0 ? 1 : 0)
        }
      }
    }

    if ([47, 49, 46].includes(this.profile.id)) {
      return false
    } else if (this.profile.id == 1) {
      return true
    }

    return true

  }

  isScancash(){
    if (this.companies) {
      const companies = this.companies.filter(c => c.company_type_id === 2)
      if (companies.length == 1) {
        let company = companies[0]
        if (this.profile.profile_type_id != 1
          && this.profile.profile_type_id != 3 
          && company
        ) {
          return !!company.fiscal_years_scancash.length > 0 ? 1 : 0
        }
      }
    }

    if ([47, 49, 46].includes(this.profile.id)) {
      return false
    } else if (this.profile.id == 1) {
      return true
    }

    return true

  }

  getCurrentDate(){
    return formatDate(this.current_date);
  }

  getFiscalYears() {
    return this.fiscal_years
  }

  static assign(obj){
    let t = new User({});
    Object.assign(t, obj)
    t.color = generateColorByString(t.email);
    return t;
  }
}

export default function (){
  const data = useContext(AppDataContext)
  const [ user ] = useState(data.user);

  return user
}